import { Link } from 'react-router-dom'
import { categories } from '@/mocks/movies'

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-primary-950 text-background-200">
      <div className="page-shell py-12 md:py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-800">
                <i className="ri-play-fill text-lg text-accent-400" />
              </span>
              <span className="text-lg font-bold text-background-50">
                麻豆传媒<span className="text-accent-400">在线</span>
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-6 text-background-300">
              专注影视作品展示与分类浏览的在线门户，覆盖电影、电视剧、短片等类别，为观众提供清晰的
              作品信息与便捷的查找体验。本站内容均为演示示例。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <span className="flex h-8 w-8 items-center justify-center rounded-full border border-primary-800 text-background-300">
                <i className="ri-mail-line text-sm" />
              </span>
              <span className="text-sm text-background-300">contact@madou-demo.com（示例邮箱）</span>
            </div>
          </div>

          <div className="md:col-span-3">
            <h3 className="text-sm font-medium text-background-50">快速导航</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-background-300">
              <li>
                <Link to="/" className="transition-colors hover:text-accent-400">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category" className="transition-colors hover:text-accent-400">
                  影视分类
                </Link>
              </li>
              <li>
                <Link to="/search" className="transition-colors hover:text-accent-400">
                  搜索作品
                </Link>
              </li>
              <li>
                <Link to="/about" className="transition-colors hover:text-accent-400">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h3 className="text-sm font-medium text-background-50">分类浏览</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-background-300">
              {categories.map((item) => (
                <li key={item.key}>
                  <Link
                    to={`/category?type=${item.key}`}
                    className="flex items-center gap-2 transition-colors hover:text-accent-400"
                  >
                    <i className={`${item.icon} text-accent-500/80`} />
                    {item.label}作品
                  </Link>
                </li>
              ))}
            </ul>
            <p className="mt-4 text-xs leading-5 text-background-400">
              免责声明：本站为影视内容展示演示站，不提供真实视频播放，所有作品信息均为示例。
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-900 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 麻豆传媒在线 · 演示站点 · 保留所有权利</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <Link to="/about" className="transition-colors hover:text-accent-400">
              版权声明
            </Link>
            <Link to="/about" className="transition-colors hover:text-accent-400">
              免责声明
            </Link>
            <Link to="/about" className="transition-colors hover:text-accent-400">
              联系方式
            </Link>
          </p>
        </div>
      </div>
    </footer>
  )
}